module.exports = __webpack_public_path__ + "static/scale-model-of-desert-dome-&-kingdoms-of-the-night-in-omaha-nebraska-c8b8553ee087e9f63642e34741b5e149.png";